import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import type { RecordFormItem } from 'types';
import { useRecordItemsSchema } from 'utils/validations/useRecordItemsSchema';
import { setAttributeValue } from 'utils/agendaRecord/agendaRecord.ts';

interface UseRecordFormSetupProps {
  items: RecordFormItem[];
  skipValidation?: boolean;
}

export const useRecordFormSetup = ({ items, skipValidation = false }: UseRecordFormSetupProps) => {
  const form = useForm({
    defaultValues: {},
    resolver: yupResolver(useRecordItemsSchema(items, skipValidation)),
    mode: 'onBlur',
  });

  const { reset } = form;

  useEffect(() => {
    if (items.length > 0) {
      const values = items.reduce<Record<string, string>>((acc, { formItem, attribute }) => {
        const type = formItem.definition.type ?? '';
        const value = setAttributeValue(type, attribute, false, formItem.definition);
        acc[formItem.id] = value;
        return acc;
      }, {});

      reset(values);
    }
  }, [items, reset]);

  return form;
};
